<script>
export default {
  props: {
    size: {
      type: Number,
      default: 16
    }
  }
}
</script>